





















































































































import CHeading from './CHeading.vue';
import EditorLinkPlaceholder from '@/components/EditorLinkPlaceholder.vue';
import CLoader from './CLoader.vue';
import Vue from 'vue';
import { FacebookIcon, TwitterIcon } from 'vue-feather-icons';
import FooterLinks from '@/components/FooterLinks.vue';

export default Vue.extend({
    name: 'editor-generating',
    components: {
        CHeading,
        EditorLinkPlaceholder,
        CLoader,
        FacebookIcon,
        TwitterIcon,
        FooterLinks
    },
    props: {
        allCharacters: {
            type: Array,
            default: () => []
        },
        links: {
            type: Array
        },
        subscribeId: {}
    },
    computed: {
        state() {
            return (this.links as any[]).length !==
                (this.allCharacters as any[]).length
                ? 'loading'
                : 'idle';
        }
    }
});
